// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedFootPedalAddOnError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M6 3H18V11.5383C18.2465 11.513 18.4968 11.5 18.75 11.5C19.1763 11.5 19.5939 11.5368 20 11.6074V0H4V24H13.75C13.148 23.4265 12.6445 22.7505 12.2675 22H6V3Z" class="svg-bg"/>
  <path d="M11.7126 17C11.5737 17.5604 11.5 18.1466 11.5 18.75 11.5 19.1763 11.5368 19.5939 11.6074 20H9L8 17H11.7126ZM14.3335 13C13.3266 13.7746 12.5289 14.8077 12.0397 16L8 16 9 13H14.3335ZM13.4976 7.5C13.4976 8.32843 12.826 9 11.9976 9 11.1691 9 10.4976 8.32843 10.4976 7.5 10.4976 6.67157 11.1691 6 11.9976 6 12.826 6 13.4976 6.67157 13.4976 7.5Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedFootPedalAddOnError is a generated icon component.
 */
let IconMedFootPedalAddOnError = IconMedFootPedalAddOnError_1 = class IconMedFootPedalAddOnError extends IconBaseElement {
    render() {
        return html `${IconMedFootPedalAddOnError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedFootPedalAddOnError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedFootPedalAddOnError = IconMedFootPedalAddOnError_1 = __decorate([
    customElement('zui-icon-med-foot-pedal-add-on-error')
], IconMedFootPedalAddOnError);
export { IconMedFootPedalAddOnError };
